/**
 * @generated SignedSource<<bb720bc5fcdb04ef41d77e576928cf25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineScheduleType = "DAILY" | "MONTHLY" | "WEEKLY";
export type TeamScheduleHistoryScreen_teamRefetch$variables = {
  after?: string | null;
  first?: number | null;
  freq: RoutineScheduleType;
  id: string;
};
export type TeamScheduleHistoryScreen_teamRefetch$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleHistoryMasterList_team">;
  } | null;
};
export type TeamScheduleHistoryScreen_teamRefetch = {
  response: TeamScheduleHistoryScreen_teamRefetch$data;
  variables: TeamScheduleHistoryScreen_teamRefetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "freq"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "freq",
    "variableName": "freq"
  }
],
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaskExecutionCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamScheduleHistoryScreen_teamRefetch",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeamScheduleHistoryMasterList_team"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamScheduleHistoryScreen_teamRefetch",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "TeamScheduleConnection",
                "kind": "LinkedField",
                "name": "teamSchedules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamScheduleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "label",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "includeInlineRoutines",
                                "value": true
                              }
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "events",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isTeamScheduleEventOccasion"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "type": "RoutineOccasion",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskExecutionCheck",
                                    "kind": "LinkedField",
                                    "name": "taskExecution",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RoutineOccasion",
                                        "kind": "LinkedField",
                                        "name": "routineOccasion",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TeamScheduleInlineRoutineOccasion",
                                "abstractKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": "events(includeInlineRoutines:true)"
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": [
                  "freq"
                ],
                "handle": "connection",
                "key": "TeamScheduleHistoryScreen__teamSchedules",
                "kind": "LinkedHandle",
                "name": "teamSchedules"
              }
            ],
            "type": "Team",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b12cf6421c29f1702db88e1acaad515c",
    "id": null,
    "metadata": {},
    "name": "TeamScheduleHistoryScreen_teamRefetch",
    "operationKind": "query",
    "text": "query TeamScheduleHistoryScreen_teamRefetch(\n  $after: String\n  $first: Int\n  $freq: RoutineScheduleType!\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...TeamScheduleHistoryMasterList_team\n    id\n  }\n}\n\nfragment TeamScheduleHistoryMasterListItem_teamSchedule on TeamSchedule {\n  id\n  label\n  events(includeInlineRoutines: true) {\n    __typename\n    ...TeamScheduleStatusRow_teamScheduleEventOccasion\n    id\n  }\n}\n\nfragment TeamScheduleHistoryMasterList_team on Team {\n  teamSchedules(freq: $freq, first: $first, after: $after) {\n    edges {\n      node {\n        id\n        ...TeamScheduleHistoryMasterListItem_teamSchedule\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment TeamScheduleSectionHeaderStatusDot_routineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  totalTaskExecutionCount\n}\n\nfragment TeamScheduleStatusRow_teamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  ... on RoutineOccasion {\n    ...TeamScheduleSectionHeaderStatusDot_routineOccasion\n  }\n  ... on TeamScheduleInlineRoutineOccasion {\n    taskExecution {\n      routineOccasion {\n        ...TeamScheduleSectionHeaderStatusDot_routineOccasion\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "58d5bef137eaa357629c8c89aecf93cc";

export default node;
